import { ENDPOINTS } from '../../utils/constants';

export async function fetchAdminCompetitions() {
  const res = await fetch(`/rapi${ENDPOINTS.ADMIN_COMPETITIONS}`);
  return res.json();
}

export async function fetchAdminCompetition(id) {
  const res = await fetch(`/rapi${ENDPOINTS.ADMIN_COMPETITIONS}/${id}`);
  return res.json();
}

export async function fetchAdminCompetitionEvent(id) {
  const res = await fetch(`/rapi${ENDPOINTS.COMPETITION_EVENTS}/${id}`);
  return res.json();
}

export async function createAdminCompetitionEvent(payload) {
  try {
    const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITIONS}/${payload.competition_id}/${ENDPOINTS.COMPETITION_EVENTS}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      }
    )

    return res
  } catch (error) {
    throw new Error(`Unexpected Error: ${error}`)
  }
}

export async function updateAdminCompetitionEvent(payload) {
  try {
    const res = await fetch(
      `/rapi${ENDPOINTS.COMPETITION_EVENTS}/${payload.id}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      }
    )

    return res
  } catch (error) {
    throw new Error(`Unexpected Error: ${error}`)
  }
}

export async function updateAdminCompetition(payload) {
  try {
    const res = await fetch(
      `/rapi${ENDPOINTS.ADMIN_COMPETITIONS}/${payload.id}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      }
    )

    return res
  } catch (error) {
    throw new Error(`Unexpected Error: ${error}`)
  }
}

export async function createCompetition(payload) {
  try {
    const res = await fetch(
      `/rapi${ENDPOINTS.ADMIN_COMPETITIONS}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      }
    )

    return res
  } catch (error) {
    throw new Error(`Unexpected Error: ${error}`)
  }
}

export async function deleteCompetitionEvent(eventId) {
  const url = `/rapi${ENDPOINTS.COMPETITION_EVENTS}/${eventId}`;
  try {
    const res = await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to delete event');
  } catch (err) {
    throw new Error(err);
  }
}


export async function deleteCompetition(id) {
  const url = `/rapi${ENDPOINTS.ADMIN_COMPETITIONS}/${id}`;
  try {
    const res = await fetch(url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to delete competition');
  } catch (err) {
    throw new Error(err);
  }
}

export async function syncRepOptions() {
  const url = `/rapi${ENDPOINTS.TEAM_MEMBER_OPTIONS}/sync_rep_options`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to sync rep options');
    return res.json()
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchMostRecentRepSync() {
  const url = `/rapi${ENDPOINTS.TEAM_MEMBER_OPTIONS}/most_recent_rep_sync`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
    });
    if (!res.ok) throw new Error('Failed to fetch most recent rep sync');
    return res.json()
  } catch (err) {
    throw new Error(err);
  }
}